import { render } from "./CustomerDetail.vue?vue&type=template&id=02136440&scoped=true"
import script from "./CustomerDetail.vue?vue&type=script&lang=js"
export * from "./CustomerDetail.vue?vue&type=script&lang=js"

import "./CustomerDetail.vue?vue&type=style&index=0&id=02136440&scoped=true&lang=css"

import exportComponent from "/Users/shohei/workspace/soei_project/measure_rep_mng/vue3_measure_rep_mng/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02136440"]])

export default __exports__